import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../../../services/api/axios";

const fetchPayoutPartners = async (search, currencyCode, payoutMethodUuid) => {
  const params = {};
  if (search) params.search = search;
  if (currencyCode) params.currencyCode = currencyCode;
  if (payoutMethodUuid) params.payoutMethodUuid = payoutMethodUuid;
  const response = await api.get("/v1/admin/business/payout-partner-settings", {
    params: Object.keys(params).length ? params : undefined,
  });
  return response.data;
};

export const usePayoutPartners = (search, currencyCode, payoutMethodUuid) => {
  return useQuery({
    queryKey: ["payout-partner-settings", search, currencyCode, payoutMethodUuid],
    queryFn: () => fetchPayoutPartners(search, currencyCode, payoutMethodUuid),
    refetchOnWindowFocus: false,
  });
};

const fetchPayoutMethods = async (currencyCode, countryCode) => {
  const params = {};
  if (currencyCode) params.currencyCode = currencyCode;
  if (countryCode) params.countryCode = countryCode;
  const response = await api.get("/v1/admin/business/payout-methods", {
    params: Object.keys(params).length ? params : undefined,
  });
  return response.data;
};

export const usePayoutMethods = (currencyCode, countryCode, options = {}) => {
  return useQuery({
    queryKey: ["payout-methods", currencyCode, countryCode],
    queryFn: () => fetchPayoutMethods(currencyCode, countryCode),
    refetchOnWindowFocus: false,
    ...options,
  });
};

const fetchPayoutProviders = async () => {
  const response = await api.get("/v1/admin/business/payout-providers");
  return response.data;
};

export const usePayoutProviders = () => {
  return useQuery({
    queryKey: ["payout-providers"],
    queryFn: fetchPayoutProviders,
    refetchOnWindowFocus: false,
  });
};

const createPayoutPartner = async (payload) => {
  const { data } = await api.post("/v1/admin/business/payout-partner-settings", payload);
  return data;
};

export const useCreatePayoutPartner = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: createPayoutPartner,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["payout-partner-settings"] });
    },
  });
};

const updatePayoutPartner = async ({ uuid, payload }) => {
  const { data } = await api.patch(
    `/v1/admin/business/payout-partner-settings/${uuid}`,
    payload
  );
  return data;
};

export const useUpdatePayoutPartner = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updatePayoutPartner,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["payout-partner-settings"] });
    },
  });
};
